export default __webpack_public_path__ + "static/edu-6c71f2212f0cbf0be2c1ef9cfbb67b69.svg";